import React from 'react';
import PropTypes from 'prop-types';
import { ButtonStyled, ButtonStyledLink, LinkStyled, IconContainer } from './styles';

const Button = React.forwardRef(
  (
    { to, iconLeft, iconRight, disabled, children, label, onClick, block, link, style, ...rest },
    ref
  ) => {
    const Wrapper =
      to && !disabled
        ? p => (
            <LinkStyled to={to} block={block ? 1 : 0}>
              {p.children}
            </LinkStyled>
          )
        : React.Fragment;
    return link ? (
      <Wrapper>
        <ButtonStyledLink
          ref={ref}
          role="button"
          aria-disabled={disabled}
          iconLeft={iconLeft}
          iconRight={iconRight}
          disabled={disabled}
          style={style}
          onClick={!disabled ? onClick : undefined}
          {...rest}
        >
          {iconLeft && <IconContainer left>{iconLeft}</IconContainer>}
          {children || label}
          {iconRight && <IconContainer right>{iconRight}</IconContainer>}
        </ButtonStyledLink>
      </Wrapper>
    ) : (
      <Wrapper>
        <ButtonStyled
          ref={ref}
          role="button"
          aria-disabled={disabled}
          iconLeft={iconLeft}
          iconRight={iconRight}
          block={block}
          disabled={disabled}
          onClick={!disabled ? onClick : undefined}
          style={style}
          {...rest}
        >
          {iconLeft && <IconContainer left>{iconLeft}</IconContainer>}
          {children || label}
          {iconRight && <IconContainer right>{iconRight}</IconContainer>}
        </ButtonStyled>
      </Wrapper>
    );
  }
);

Button.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]),
  iconLeft: PropTypes.element,
  iconRight: PropTypes.element,
  block: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  link: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node,
};

Button.defaultProps = {
  color: 'primary',
};

export default Button;
